import {
  TiVoAppVariant,
  TiVoAppVariantDraft,
  TiVoAppVariantVersion,
  TiVoPublications,
  VariantPublications,
} from "./types";

const DRAFT = "draft" as const;
export const transformDraftToVariant = (
  draftData: TiVoAppVariantDraft
): TiVoAppVariant => ({
  ...draftData,
  ...draftData.data.attributes,
  status: [DRAFT],
  id: DRAFT, // For the transformed Draft we can overwrite id with "Draft". This is because we need to differentiate between drafts and variants
});

export const transformDraftToVariantVersion = (
  draftData: TiVoAppVariantDraft
): TiVoAppVariantVersion => ({
  ...draftData,
  ...draftData.data.attributes,
});

export const transformVariantPublications = (
  variantPublications: VariantPublications[],
  platformId: string
): TiVoPublications[] => {
  return variantPublications.map((variantPublication) => ({
    id: variantPublication.id,
    oems: variantPublication.oems,
    platforms: [
      {
        platformId,
        publications: variantPublication.publications,
      },
    ],
    variant: variantPublication.variant,
  }));
};
